import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable, Subject, Subscription, firstValueFrom, take } from "rxjs";
import { environment } from "src/environments/environment";
import { EstatusJSON } from "../../models/EstatusJSON";
import { IApiBase } from "./Interface/IApiBase.interface";
import { CatalogPaginationRequest } from "../../models/CatalogPagination/CatalogPaginationRequest";
import { FilterRequest } from "../../models/Filter/FilterRequest";

@Injectable({
  providedIn: "root",
})
export class PermissionAPIService implements IApiBase{
  configUrl: string;

  constructor(
    private http: HttpClient,
  ) {
    this.configUrl = environment.host;
  }
  insert() {
    throw new Error("Method not implemented.");
  }
  update(datos: any) {
    throw new Error("Method not implemented.");
  }
  delete(id: any) {
    throw new Error("Method not implemented.");
  }
  getFilterValues(request: FilterRequest[]) {
    throw new Error("Method not implemented.");
  }
  getPage(pageRequest: CatalogPaginationRequest) {
    throw new Error("Method not implemented.");
  }
  getCount(pageRequest: CatalogPaginationRequest) {
    throw new Error("Method not implemented.");
  }

  GetList(role:string = ""): Observable<EstatusJSON> {
    console.log("role",role);
    return this.http.get<EstatusJSON>(this.configUrl + "/api/Permission/GetList?"+"role="+role);;
  }
}
